export const PROFESSIONAL_CONTRACT_TYPE_INITIAL_FILTER_FIELDS = ['name', 'description', 'status']
